import { render, staticRenderFns } from "./Guide_theQuerV2_ShowInfo.vue?vue&type=template&id=f0a07c78&scoped=true&class=guide_dialog&"
import script from "./Guide_theQuerV2_ShowInfo.vue?vue&type=script&lang=js&"
export * from "./Guide_theQuerV2_ShowInfo.vue?vue&type=script&lang=js&"
import style0 from "./Guide_theQuerV2_ShowInfo.vue?vue&type=style&index=0&id=f0a07c78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a07c78",
  null
  
)

export default component.exports